/**
 * Hook to lock/unlock body scroll when mobile drawer is open
 * Prevents background scrolling when overlay is visible
 */
import { useEffect } from 'react';

export const useBodyLock = (isLocked: boolean) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    if (isLocked) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      const originalPaddingRight = document.body.style.paddingRight;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
      
      return () => {
        document.body.style.overflow = originalStyle;
        document.body.style.paddingRight = originalPaddingRight;
      };
    }
  }, [isLocked]);
};

